import type { RouteRecordRaw } from 'vue-router'

import { generateWebviewRoutes } from '~/scopes/webviews/generateWebviewRoutes'
import redirectIfWebview from '~/scopes/webviews/middleware/redirectIfWebview'

import { CMS } from '../cms/routes-names'

export const PDF = {
  TERMS_MERCHANT_ONBOARDING: 'terms_merchant_onboarding',
  CERTIFICATE_TO_TRANSPORT_INVESTIGATION:
    'certificate_to_transport_investigation',
}

export const LEGAL = {
  GET_VISITOR_ID: 'get_visitor_id',
  COOKIES: 'cookies',
  REFER_FRIEND: 'refer_friend_terms_conditions',
}

export default (): RouteRecordRaw[] => {
  const legalRoutes: RouteRecordRaw[] = [
    {
      path: 'cookies',
      name: LEGAL.COOKIES,
      component: () => import('~/scopes/legal/pages/Cookies.vue'),
      meta: {
        owners: ['bot-squad-content-front'],
      },
    },
    {
      path: 'get-my-visitor-id',
      name: LEGAL.GET_VISITOR_ID,
      component: () => import('~/scopes/legal/pages/VisitorId.vue'),
      meta: {
        owners: ['bot-squad-content-front'],
      },
    },
  ]

  const legalCmsRoutes: RouteRecordRaw[] = [
    {
      path: 'legal/previous/:pageName',
      component: () => import('~/scopes/cms/Landing.vue'),
      meta: {
        owners: ['bot-squad-content-front'],
        middleware: ['hide-consent-notice', redirectIfWebview],
      },
      children: [
        {
          name: CMS.LEGAL_PREVIOUS_VERSION,
          path: '',
          component: () =>
            import('~/scopes/legal/pages/LegalTemplate/LegalTemplate.vue'),
          meta: {
            middleware: ['hide-consent-notice', redirectIfWebview],
            noCookieModal: true,
            owners: ['bot-squad-content-front'],
          },
        },
      ],
    },
    {
      path: 'legal/:pageName',
      component: () => import('~/scopes/cms/Landing.vue'),
      children: [
        {
          name: CMS.LEGAL_PAGE,
          path: '',
          component: () =>
            import('~/scopes/legal/pages/LegalTemplate/LegalTemplate.vue'),
          meta: {
            middleware: ['hide-consent-notice', redirectIfWebview],
            noCookieModal: true,
            owners: ['bot-squad-content-front'],
          },
        },
      ],
    },
  ]

  const webviewRoutes = generateWebviewRoutes(legalCmsRoutes)

  return [...legalRoutes, ...legalCmsRoutes, ...webviewRoutes]
}
